/*
 * File: AsanaLayout.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd April 2025 3:47:29 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 5th November 2025 10:22:38 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useRef, useState } from 'react';
import {
  Badge,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomTab from '../../../shared/CustomTab/CustomTab';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import { Link, useParams } from 'react-router-dom';
import CustomChip from '../../../shared/CustomChip/CustomChip';
import AsanaCard from '../AsanaCard/AsanaCard';
import AsanaTable from '../AsanaTable/AsanaTable';
import { AsanaService } from '../../../../service/asana.service';
import CustomSearch from '../../../shared/CustomSearch/CustomSearch';
import CustomTextField from '../../../shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../customHook/useInput';
import AsanaAddProject from '../AsanaAddProject/AsanaAddProject';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import InfiniteScrollColumn from '../../../shared/InfiniteScrollColumn/InfiniteScrollColumn';
import InfiniteScroll from 'react-infinite-scroll-component';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};
const AsanaLayout = ({
  team,
  getProjects,
  projects,
  loadingTeam,
  loadingProject,
  setCopy,
  setProjects,
  getStats,
  nextStart,
}: {
  team: any[] | undefined;
  getProjects: (query?: any, next?: boolean, add?: boolean) => Promise<void>;
  projects: any[] | undefined;
  loadingTeam: boolean;
  loadingProject: boolean;
  setCopy: React.Dispatch<React.SetStateAction<string>>;
  setProjects: React.Dispatch<React.SetStateAction<any[] | undefined>>;
  getStats: () => Promise<void>;
  nextStart: {
    nextStart: number;
    offset: string | null;
  };
}) => {
  // const {
  //   handleChange: handleSearchChange,
  //   handleBlur: handleSearchBlur,
  //   value: searchInput,
  //   invalid: invalidSearch,
  //   didChange: didSearchChange,
  // } = useInput('', () => {
  //   return true;
  // });

  const asanaToken = localStorage.getItem('asana-token') || '';
  const search = useRef('');
  const deletedProject = sessionStorage.getItem('delete-project');
  const layoutSaved = sessionStorage.getItem('layout');
  const [layout, setLayout] = useState<'column' | 'row'>(layoutSaved ? 'row' : 'column');
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [message, setMessage] = useState(deletedProject ? 'Project deleted successfully' : '');
  const [isSearching, setIsSearching] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const params = useParams();

  const TimeRange = ['Day', 'Week', 'Month'];
  const [filter, setFilter] = useState<{
    teams: { id: string; name: string }[];
    members: { id: string; name: string }[];
    owners: { id: string; name: string }[];
    portfolios: { id: string; name: string }[];
    statuses: { value: string; label: string }[];
  }>({
    teams: [],
    members: [],
    owners: [],
    portfolios: [],
    statuses: [],
  });
  const [overdueFilter, setOverdueFilter] = useState(false);

  const [selectedItems, setSelectedItems] = useState<{
    members: string[];
    owners: string[];
    statuses: string[];
  }>({
    members: [],
    owners: [],
    statuses: [],
  });

  const [modalOpen, setModalOpen] = React.useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  // const AsanaTabs = [
  //   {
  //     label: 'Deals',
  //     id: 1,
  //     isHidden: false,
  //     Component: <Box>Deals</Box>,
  //   },
  //   {
  //     label: 'Clients',
  //     id: 2,
  //     isHidden: false,
  //     Component: <Box>Clients</Box>,
  //   },
  //   {
  //     label: 'Internal',
  //     id: 3,
  //     isHidden: false,
  //     Component: <Box>Internal</Box>,
  //   },
  //   {
  //     label: 'Community Outreach',
  //     id: 4,
  //     isHidden: false,
  //     Component: <Box>Community Outreach</Box>,
  //   },
  // ];
  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };
  const handleClearAll = () => {
    setOverdueFilter(false);
    setSelectedItems({
      members: [],
      owners: [],
      statuses: [],
    });
    //  getTask(false, true);
    setAnchorEl(null);
    getProjects();
  };
  const handleTaskFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOverdueFilter(e.target.checked);
  };
  const applyFilter = () => {
    //  getTask();
    getProjects(
      {
        ...(selectedItems?.members?.length && {
          member: selectedItems?.members?.map((item) => item),
        }),
        ...(selectedItems?.owners?.length && {
          owners: selectedItems?.owners?.map((item) => item),
        }),
        ...(selectedItems?.statuses?.length && {
          status: selectedItems?.statuses?.map((item) => item),
        }),
        ...(activeChip.length && { team: activeChip }),
        ...(overdueFilter && { overdue: true }),
      },
      false,
      true,
    );
    setAnchorEl(null);
  };
  // stack chip
  const [activeChip, setActiveChip] = useState<string[]>([]); // Track if the chip is active
  const handleClickChip = (val: string) => {
    const unique = activeChip.filter((valRef: string) => val === valRef);
    // console.log(unique, activeChip);
    getProjects(
      {
        ...(selectedItems?.members?.length && {
          member: selectedItems?.members?.map((item) => item),
        }),
        ...(selectedItems?.owners?.length && {
          owners: selectedItems?.owners?.map((item) => item),
        }),

        team: unique?.length
          ? activeChip.filter((valRef: string) => val !== valRef)
          : [...activeChip, val],
      },
      false,
      true,
    );
    setActiveChip((prev: string[]) =>
      unique?.length ? prev.filter((valRef: string) => val !== valRef) : [...prev, val],
    ); // Toggle the active state on click
  };

  const getFilter = async () => {
    try {
      const res = await AsanaService.getAsanaFilter();
      console.log(res);
      setFilter(res);
    } catch (err) {
      console.log(err);
    }
  };
  const handleClose = () => {
    setMessage('');
  };
  useEffect(() => {
    asanaToken && getFilter();
    sessionStorage.removeItem('delete-project');
  }, [asanaToken]);
  useEffect(() => {
    if (!modalOpen && asanaToken) {
      getProjects(
        {
          ...(selectedItems?.members?.length && {
            member: selectedItems?.members?.map((item) => item),
          }),
          ...(selectedItems?.owners?.length && {
            owners: selectedItems?.owners?.map((item) => item),
          }),
          ...(activeChip.length && { team: activeChip }),
          ...(overdueFilter && { overdue: true }),
        },
        false,
        true,
      );
      getStats();
    }
  }, [modalOpen]);
  const handleProjectCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setModalOpen(true);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', marginTop: '24px' }}>
      <Typography variant='heading3'>Projects</Typography>
      <Box
        sx={{
          //   padding: '24px 1.5rem 0rem 1.5rem',
          // height: '75vh',
          // display: 'flex',
          // flexDirection: 'column',
          // flex: 1,
          position: 'relative',
          // backgroundColor: zeplinColor?.Neutral1,
          // zIndex: 1,
        }}
      >
        {' '}
        {/* <CustomTab tabs={AsanaTabs} handleChange={handleChange} value={value} /> */}
        <Stack direction='row' spacing={1}>
          {loadingTeam || isSearching ? (
            [1, 2, 3, 4, 5].map((val) => (
              <CustomChip
                handleClick={handleClickChip}
                active={activeChip}
                text={''}
                count={0}
                value={val.toString()}
                height='48px'
                loading={loadingTeam}
                key={val}
              />
            ))
          ) : team?.length ? (
            team?.map((item) => (
              <CustomChip
                handleClick={handleClickChip}
                active={activeChip}
                text={item?.name}
                count={0}
                value={item?.id}
                height='48px'
                loading={loadingTeam}
                key={item?.id}
              />
            ))
          ) : (
            <CustomChip
              handleClick={() => {}}
              active={activeChip}
              text={'N/A'}
              count={0}
              value={'N/A'}
              height='48px'
              loading={loadingTeam}
              key={'N/A'}
            />
          )}
          {/* <CustomChip
            handleClick={handleClickChip}
            active={activeChip}
            text='Clients'
            count={0}
            value='Clients'
            height='48px'
          />
          <CustomChip
            handleClick={handleClickChip}
            active={activeChip}
            text='Internal'
            count={0}
            value={'Internal'}
            height='48px'
          />
          <CustomChip
            handleClick={handleClickChip}
            active={activeChip}
            text='Community Outreach'
            count={0}
            value={'Community Outreach'}
            height='48px'
          /> */}
        </Stack>
        <Box
          sx={{
            position: 'absolute',
            top: '0rem',
            right: '0rem',
            display: 'flex',
            gap: '16px',
            // width: '595px',
          }}
        >
          <CustomSearch
            setProjects={setProjects}
            getProjects={(text: string) => {
              search.current = text;
              setIsSearching(true);
              getProjects(
                {
                  ...(selectedItems?.members?.length && {
                    member: selectedItems?.members?.map((item) => item),
                  }),
                  ...(selectedItems?.owners?.length && {
                    owners: selectedItems?.owners?.map((item) => item),
                  }),
                  ...(activeChip.length && { team: activeChip }),
                  ...(overdueFilter && { overdue: true }),
                  search: text,
                },
                false,
                true,
              ).finally(() => {
                setIsSearching(false); // Clear searching flag when done
              });
            }}
          />
          {/* <Box
            sx={{
              borderRadius: '100px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '10px',
              width: '48px',
              height: '48px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            <img src={`/assets/sort-icon.svg`} width='20px' height='20px' />
          </Box> */}
          <Badge
            badgeContent={
              anchorEl
                ? 0
                : Object.values(selectedItems).reduce(
                    (prev, val) => (val?.length ? prev + 1 : prev),
                    overdueFilter ? 1 : 0,
                  )
            }
            color='primary'
            sx={{ '.MuiBadge-badge': { top: '0.7rem', right: '0.2rem' } }}
          >
            <LightTooltip
              title={
                <Typography variant='body3' color={zeplinColor.Neutral1}>
                  Filter
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box
                sx={{
                  borderRadius: '50px',
                  width: '48px',
                  height: '48px',
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  // p: '0px 10px',
                  backgroundColor: zeplinColor.Neutral1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={(e) => handleClick(e)}
              >
                <img src={'/assets/filter.svg'} width={20} height={20} />
              </Box>
            </LightTooltip>
          </Badge>
          <Box
            sx={{
              borderRadius: '50px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '6px',
              width: '92px',
              height: '48px',
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: zeplinColor.Neutral1,
              flex: 1,
            }}
          >
            {layout === 'column' ? (
              <img
                src={`/assets/selected-col-layout.svg`}
                width='36px'
                height='36px'
                onClick={() => {
                  setLayout('column');
                  sessionStorage.removeItem('layout');
                }}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <img
                src={`/assets/column-layout-icon.svg`}
                width='20px'
                height='20px'
                onClick={() => {
                  setLayout('column');
                  sessionStorage.removeItem('layout');
                }}
                style={{ cursor: 'pointer' }}
              />
            )}
            {layout === 'row' ? (
              <img
                src={`/assets/selected-row-layout.svg`}
                width='36px'
                height='36px'
                onClick={() => {
                  setLayout('row');
                  sessionStorage.setItem('layout', 'row');
                }}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <img
                src={`/assets/row-layout-icon.svg`}
                width='20px'
                height='20px'
                onClick={() => {
                  setLayout('row');
                  sessionStorage.setItem('layout', 'row');
                }}
                style={{ cursor: 'pointer' }}
              />
            )}
          </Box>
          {projects?.length ? (
            <LightTooltip
              title={
                <Typography variant='body3' color={zeplinColor.Neutral1}>
                  New project
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box sx={{ width: '156px' }}>
                <CustomButton
                  disabled={false}
                  onClick={handleProjectCreateClick}
                  variant='contained'
                  color={'primary'}
                  style={{
                    width: '100%',
                    borderRadius: '14px',
                    height: 48,
                    padding: '14px 16px',
                    '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                  }}
                  textStyle={{ color: zeplinColor.Neutral1 }}
                  text={'New Project'}
                  icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
                  // tabindex={4}
                />
              </Box>
            </LightTooltip>
          ) : (
            ''
          )}
        </Box>
        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            marginRight: '2rem',
            marginLeft: '-4rem',
          }}
        >
          <Box
            sx={{
              padding: '16px',
              width: '283px',
              //   height: params?.id ? '28rem' : '30rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Filter
              </Typography>
              <Typography
                variant='buttonSmall'
                color={
                  Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                    ? zeplinColor.Neutral8
                    : zeplinColor.Brand1
                }
                onClick={
                  Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                    ? () => {}
                    : handleClearAll
                }
                sx={{
                  cursor:
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                      ? 'default'
                      : 'pointer',
                }}
              >
                Clear All
              </Typography>
            </Box>
            {/* <div> */}
            <FormGroup
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Owners
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.owners}
                  onChange={(e) => handleSelection(e, 'owners')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px 0px 0px',
                      }}
                      label='Owners'
                    />
                  }
                  renderValue={(selected) =>
                    selected
                      .map((item) => filter?.owners?.find((owner) => owner?.id === item)?.name)
                      .join(',')
                  }
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                  )}
                >
                  {filter?.owners.map((item) => (
                    <MenuItem key={item?.id} value={item?.id}>
                      <Checkbox
                        checked={selectedItems?.owners.indexOf(item?.id) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {params?.id ? (
                ''
              ) : (
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Members
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    )}
                    id='demo-multiple-name'
                    multiple
                    value={selectedItems.members}
                    onChange={(e) => handleSelection(e, 'members')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          padding: '0px 14px 0px 0px',
                        }}
                        label='Members'
                      />
                    }
                    // IconComponent={() => (
                    //   <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    // )}
                    renderValue={(selected) =>
                      selected
                        .map((item) => filter?.members?.find((member) => member?.id === item)?.name)
                        .join(',')
                    }
                    MenuProps={MenuProps}
                  >
                    {filter?.members.map((item) => (
                      <MenuItem key={item?.id} value={item?.id}>
                        <Checkbox
                          checked={selectedItems?.members.indexOf(item?.id) > -1}
                          // color={zeplinColor.BasicBlack}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Status
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  value={selectedItems.statuses}
                  onChange={(e) => handleSelection(e, 'statuses')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px 0px 0px',
                      }}
                      label='Status'
                    />
                  }
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                  )}
                  renderValue={(selected) =>
                    filter?.statuses.filter((val) => val?.value === selected[0])[0].label
                  }
                  MenuProps={MenuProps}
                >
                  {filter?.statuses.map((name) => (
                    <MenuItem key={name.value} value={name.value}>
                      <Radio
                        checked={selectedItems.statuses.indexOf(name.value) > -1} // Check if this radio should be selected
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: '100%' }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={overdueFilter}
                      // defaultChecked
                      onChange={handleTaskFilter}
                      sx={{
                        width: '51px', // Track width
                        height: '31px', // Track height
                        padding: 0, // Remove internal padding for correct thumb alignment
                        '& .MuiSwitch-switchBase': {
                          padding: '1px 0px ',
                          // display: 'flex',
                          // justifyContent: 'center',
                          // alignItems: 'center',
                          margin: '2px',
                          transitionDuration: '300ms',
                          '&.Mui-checked': {
                            transform: 'translateX(20px)', // Thumb moves 20px to the right when checked
                            color: zeplinColor.Blue, // Thumb color
                            '& + .MuiSwitch-track': {
                              backgroundColor: zeplinColor.BasicBlack, // Track color when the switch is on
                              opacity: 1, // Full opacity when on
                              border: 0,
                            },
                          },
                          '&.Mui-focusVisible .MuiSwitch-thumb': {
                            color: zeplinColor.Neutral9, // Color for thumb when focused
                            border: '1px solid #fff', // Focus border
                          },
                          '&.Mui-disabled .MuiSwitch-thumb': {
                            color: '#D3D3D3', // Disabled thumb color (light gray)
                          },
                          '&.Mui-disabled + .MuiSwitch-track': {
                            opacity: 0.7, // Track opacity when disabled
                          },
                        },
                        '& .MuiSwitch-thumb': {
                          boxSizing: 'border-box',
                          width: '25px', // Thumb width
                          height: '25px', // Thumb height
                          backgroundColor: zeplinColor.Neutral1, // Thumb color
                        },
                        '& .MuiSwitch-track': {
                          borderRadius: '100px', // Border radius for the off state (left side rounded)
                          backgroundColor: zeplinColor.Neutral5, // Track color when off
                          opacity: 0.6, // Track opacity when off
                          transition: 'background-color 300ms ease', // Smooth transition when toggling
                        },
                      }}
                    />
                  }
                  label='Overdue task'
                  labelPlacement='start'
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginLeft: 0,
                    width: '100%',
                  }}
                />
              </FormControl>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                <CustomButton
                  onClick={applyFilter}
                  variant='contained'
                  disabled={
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                  }
                  color={'primary'}
                  style={{ width: '100%', borderRadius: 14, height: 56 }}
                  textStyle={{
                    color:
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                        ? zeplinColor.Neutral8
                        : zeplinColor.Neutral1,
                  }}
                  text={'Apply'}
                />
              </Box>
            </FormGroup>
          </Box>
        </CustomPopOver>
      </Box>
      <>
        {layout === 'column' ? (
          <Box
            sx={
              {
                // overflowY: 'scroll',
                // height: '100vh',
                // paddingBottom: '10rem',
              }
            }
          >
            {loadingProject && !projects?.length ? (
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => (
                  <AsanaCard
                    item={{
                      archived: false,
                      id: '',
                      members: [{ id: '', name: '', photo: null }],
                      name: '',
                      overdue: true,
                      owner: { id: '', name: '' },
                      portfolios: [],
                      progress: 0,
                      team: { id: '', name: '' },
                      totalTasks: 0,
                    }}
                    loading={loadingProject}
                    setCopy={setCopy}
                    getProjects={() => {
                      getProjects({
                        ...(selectedItems?.members?.length && {
                          member: selectedItems?.members?.map((item) => item),
                        }),
                        ...(selectedItems?.owners?.length && {
                          owners: selectedItems?.owners?.map((item) => item),
                        }),
                        ...(activeChip.length && { team: activeChip }),
                        ...(overdueFilter && { overdue: true }),
                      });
                      getStats();
                    }}
                    setMessage={setMessage}
                  />
                ))}
              </Box>
            ) : !loadingProject && !projects?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '32px',
                  flex: 1,
                  marginTop: '9rem',
                  // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
                  // height: '100vh',
                  // paddingBottom: '30%',
                  // overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    // flex: 1,
                    // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
                  }}
                >
                  {' '}
                  <img
                    src={
                      search?.current?.length
                        ? '/assets/search-not-found.svg'
                        : Object.values(selectedItems).reduce(
                            (prev, val) => (val?.length ? prev + 1 : prev),
                            overdueFilter ? 1 : 0,
                          )
                        ? '/assets/no-filter.svg'
                        : '/assets/no-projects.svg'
                    }
                    width={48}
                    height={48}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '12px',
                      // flex: 1,
                      // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
                    }}
                  >
                    <Typography variant='heading3' color={zeplinColor.BasicBlack} sx={{}}>
                      {Object.values(selectedItems).reduce(
                        (prev, val) => (val?.length ? prev + 1 : prev),
                        overdueFilter ? 1 : 0,
                      ) || search?.current?.length
                        ? 'No Results Found'
                        : 'No Project Yet'}
                    </Typography>
                    <Typography
                      variant='body3'
                      color={zeplinColor.Neutral8}
                      sx={{ width: '317px', textAlign: 'center' }}
                    >
                      {search?.current?.length
                        ? 'We couldn’t find any projects matching your search. Try adjusting your keywords.'
                        : Object.values(selectedItems).reduce(
                            (prev, val) => (val?.length ? prev + 1 : prev),
                            overdueFilter ? 1 : 0,
                          )
                        ? 'Please try adjusting your filters to see relevant results.'
                        : 'Create a project to organize tasks, track progress, and move your work forward.'}
                    </Typography>
                  </Box>
                </Box>
                {search?.current?.length <= 0 && (
                  <CustomButton
                    disabled={false}
                    onClick={
                      Object.values(selectedItems).reduce(
                        (prev, val) => (val?.length ? prev + 1 : prev),
                        overdueFilter ? 1 : 0,
                      ) && !anchorEl
                        ? handleClearAll
                        : (e: any) => {
                            handleProjectCreateClick(e);
                          }
                    }
                    variant='outlined'
                    color='secondary'
                    style={{
                      width: '150px',
                      borderRadius: '14px',
                      height: '48px',
                      backgroundColor: zeplinColor.Brand1,
                      gap: '16px',
                      padding: '14px 16px',
                    }}
                    textStyle={{ color: zeplinColor.Neutral1 }}
                    text={
                      Object.values(selectedItems).reduce(
                        (prev, val) => (val?.length ? prev + 1 : prev),
                        overdueFilter ? 1 : 0,
                      )
                        ? 'Clear Filters'
                        : 'New Project'
                    }
                  />
                )}
              </Box>
            ) : (
              ''
            )}
          </Box>
        ) : projects?.length || loadingProject ? (
          <Box sx={{}}>
            <AsanaTable
              loadingProject={loadingProject}
              team={projects}
              setCopy={setCopy}
              getProjects={(offset?: boolean, add?: boolean) => {
                getProjects(
                  {
                    ...(selectedItems?.members?.length && {
                      member: selectedItems?.members?.map((item) => item),
                    }),
                    ...(selectedItems?.owners?.length && {
                      owners: selectedItems?.owners?.map((item) => item),
                    }),
                    ...(activeChip.length && { team: activeChip }),
                    ...(overdueFilter && { overdue: true }),
                  },
                  offset,
                  add,
                );
                getStats();
              }}
              setMessage={setMessage}
              nextStart={nextStart}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '32px',
              flex: 1,
              marginTop: '9rem',
              // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
              // height: '100vh',
              // paddingBottom: '30%',
              // overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '24px',
                // flex: 1,
                // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
              }}
            >
              {' '}
              <img src={'/assets/no-tasks.svg'} width={48} height={48} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '12px',
                  // flex: 1,
                  // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack} sx={{}}>
                  {Object.values(selectedItems).reduce(
                    (prev, val) => (val?.length ? prev + 1 : prev),
                    overdueFilter ? 1 : 0,
                  ) && !anchorEl
                    ? 'No Results Found'
                    : 'No Project Yet'}
                </Typography>
                <Typography
                  variant='body3'
                  color={zeplinColor.Neutral8}
                  sx={{ width: '317px', textAlign: 'center' }}
                >
                  {Object.values(selectedItems).reduce(
                    (prev, val) => (val?.length ? prev + 1 : prev),
                    overdueFilter ? 1 : 0,
                  ) && !anchorEl
                    ? 'Please try adjusting your filters to see relevant results.'
                    : 'Create a project to organize tasks, track progress, and move your work forward.'}
                </Typography>
              </Box>
            </Box>
            <CustomButton
              disabled={false}
              onClick={
                Object.values(selectedItems).reduce(
                  (prev, val) => (val?.length ? prev + 1 : prev),
                  overdueFilter ? 1 : 0,
                ) && !anchorEl
                  ? handleClearAll
                  : (e: any) => {
                      handleProjectCreateClick(e);
                    }
              }
              variant='outlined'
              color='secondary'
              style={{
                width: '150px',
                borderRadius: '14px',
                height: '48px',
                backgroundColor: zeplinColor.Brand1,
                gap: '16px',
                padding: '14px 16px',
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={
                Object.values(selectedItems).reduce(
                  (prev, val) => (val?.length ? prev + 1 : prev),
                  overdueFilter ? 1 : 0,
                ) && !anchorEl
                  ? 'Clear Filters'
                  : 'New Project'
              }
            />
          </Box>
        )}
      </>
      {layout === 'column' && projects?.length ? (
        <InfiniteScroll
          dataLength={projects?.length}
          loader={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // visibility: 'hidden',
              }}
            >
              <h4></h4>
            </Box>
          }
          next={() => {
            // console.log('next', nextStart);
            getProjects(
              {
                ...(selectedItems?.members?.length && {
                  member: selectedItems?.members?.map((item) => item),
                }),
                ...(selectedItems?.owners?.length && {
                  owners: selectedItems?.owners?.map((item) => item),
                }),
                ...(activeChip.length && { team: activeChip }),
                ...(overdueFilter && { overdue: true }),
              },
              nextStart?.offset ? true : false,
            );
            // next(true);
          }}
          hasMore={nextStart?.offset !== null ? true : false}
          height={'calc(100vh - 500px)'}
          // height={'100vh'}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            paddingBottom: '1rem',
            // overflowY: 'auto',
          }}
        >
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {projects.map((item) => (
              <AsanaCard
                item={item}
                loading={loadingProject}
                setCopy={setCopy}
                getProjects={() => {
                  getProjects({
                    ...(selectedItems?.members?.length && {
                      member: selectedItems?.members?.map((item) => item),
                    }),
                    ...(selectedItems?.owners?.length && {
                      owners: selectedItems?.owners?.map((item) => item),
                    }),
                    ...(activeChip.length && { team: activeChip }),
                    ...(overdueFilter && { overdue: true }),
                  });
                  getStats();
                }}
                setMessage={setMessage}
              />
            ))}
          </Box>
        </InfiniteScroll>
      ) : (
        ''
      )}
      <AsanaAddProject modalOpen={modalOpen} setModalOpen={setModalOpen} setMessage={setMessage} />
      <CustomAlert
        open={message ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={message ? message : ''}
            alertIcon={
              message && message?.includes('successfully') ? (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              ) : (
                <img src='/assets/error.svg' width={24} height={24} />
              )
            }
            error={!message || message?.includes('successfully') ? false : true}
          />
        }
        error={!message || message?.includes('successfully') ? false : true}
      />
    </Box>
  );
};

export default AsanaLayout;
